import { combineReducers } from 'redux';
import { enableES5 } from 'immer';
import settings from './modules/settings';
// eslint-disable-next-line import/no-named-as-default
import canvasBlocks from './modules/canvasBlocks';
import changeLog from './modules/changeLog';
import customFonts from './modules/customFonts';
import selectedBlocks from './modules/selectedBlocks';
import selectedElements from './modules/selectedElements';
import htmlOutput from './modules/htmlOutput';
import versionHistory from './modules/versionHistory';
import browser from './modules/browser';
import session from './modules/session';
import elementErrors from './modules/elementErrors';
import modals from './modules/modals';
import saving from './modules/saving';
import contentLibrary from './modules/contentLibrary';
import thirdPartyContent from './modules/thirdPartyContent';
import personalization from './modules/personalization';
import reloadTextEditor from './modules/reloadTextEditor';

enableES5();

const reducer = combineReducers({
    settings,
    canvasBlocks,
    changeLog,
    customFonts,
    selectedBlocks,
    selectedElements,
    htmlOutput,
    versionHistory,
    browser,
    session,
    elementErrors,
    modals,
    saving,
    contentLibrary,
    thirdPartyContent,
    personalization,
    reloadTextEditor,
});

export type TAppState = ReturnType<typeof reducer>;

export default reducer;
